import React from 'react';
import styled from 'astroturf/react';

import { Body as BodyBase } from 'js/design_system/Body';
import { BodyLink } from 'js/design_system/link/BodyLink';
import { User } from 'js/social/UserCard';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 46px;
  padding-top: 8px;
`;

const NameContainer = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 0;
`;

const CommenterName = styled(BodyLink)`
  color: $ds-black;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CommenterAffiliation = styled(BodyBase)`
  color: $ds-gray-dark;
`;

interface Props {
  commenter: User;
  commenterUrl?: string;
  headerMenu?: React.ReactNode;
}

const Header: React.FunctionComponent<Props> = ({
  commenter,
  commenterUrl,
  headerMenu,
}) => (
  <Container>
    <NameContainer>
      <CommenterName size="sm" bold href={commenterUrl}>
        {commenter.displayName}
      </CommenterName>

      {headerMenu}
    </NameContainer>

    {commenter.affiliation && (
      <CommenterAffiliation size="xs">
        {commenter.affiliation}
      </CommenterAffiliation>
    )}
  </Container>
);

export default Header;
